import { useEffect } from 'react'

export function useEscapeClose(enabled: boolean, onClose: () => void) {
  useEffect(() => {
    if (!enabled) {
      return
    }

    const onEscape = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' && event.key !== 'Esc') {
        return
      }

      event.preventDefault()
      onClose()
    }

    window.addEventListener('keydown', onEscape, true)

    return () => {
      window.removeEventListener('keydown', onEscape, true)
    }
  }, [enabled, onClose])
}
